import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { QueryRequestModel } from 'src/app/core/models/QueryRequestModel';
import { QueryStatus } from 'src/app/core/models/QueryStatus';
import { User } from 'src/app/core/models/user';
import { UserService } from 'src/app/core/services/user.service';
import { ClarificationQueryListService } from '../clarification-query-list.service';
import { XlsxService } from 'src/app/shared/services/xlsx.service';
import { QueryRequertTypeEnum } from 'src/app/core/models/PartnerQueryStatus';
import { NzModalService } from 'ng-zorro-antd/modal';
import { DeleteQueryComponent } from '../delete-query/delete-query.component';
import { TableColumns } from '../Shared/TableColumns';

@Component({
  selector: 'app-my-query-list',
  standalone: false,
  templateUrl: './my-query-list.component.html',
  styleUrl: './my-query-list.component.less'
})
export class MyQueryListComponent {
  currentUser: User = new User();
  myQueryRequest: QueryRequestModel[] = [];
  filteredQueryRequest: QueryRequestModel[] = [];
  selectedQuery: QueryRequestModel = new QueryRequestModel();
  queryResponseEnum = QueryStatus.Responded;
  queryDeleteByAdminEnum = QueryStatus.DeletedByRFCAdmin;
  queryDeleteByPartnerEnum = QueryStatus.DeletedByPartner;

  queryAssgnToDepRepEnum = QueryStatus.AssignedToDeptRep;
  queryRecycledEnum = QueryStatus.Recycled;
  queryAnsweredBySponsorEnum = QueryStatus.QueryAnsweredBySponsor;
  queryAnsweredByDeptEnum = QueryStatus.QueryAnsweredByDeptRep;
  partnerTableColumns = TableColumns.PARTNER_TABLE_COLUMNS;
  nonPartnerTableColumns = TableColumns.getFilteredColumns(TableColumns.NON_PARTNER_TABLE_COLUMNS, ['Action']);

 

  config: any;
  currentPageSize = 10;
  sortingName: string = "RequestedDate";
  isDesc: boolean = true;
  searchText: string = "";

  exportData: { Title: string; Data: any[]; Headers: string[] }[] = [];

  constructor(private router: Router,
    private datepipe: DatePipe,
    //private toastrService: ToastrService,
    private userService: UserService,
    //private modalService: NgbModal,
    private modalService: NzModalService,
    private queryService: ClarificationQueryListService,
    public xlxsService: XlsxService)
    { }
    ngOnInit() {
      this.currentUser = this.userService.getCurrentUser();
      if (!this.currentUser.IsRFCAdmin) {
        this.queryService
          .getAllQueries(this.currentUser.User_Code ?? 0, QueryRequertTypeEnum.MyQueryRequest, 0)
          .subscribe({
            next: (response: any) => {
              this.filteredQueryRequest = this.myQueryRequest = response.output.filter(
                (s: QueryRequestModel) => s.QueryDetailsStatus
              );
              this.config = {
                itemsPerPage: this.currentPageSize,
                currentPage: 1,
                totalItems: 0,
              };
            },
            error: (error) => {
              // Handle error
              console.log("Error occurred while fetching all query details", error);
            },
          });
      } else {
        this.redirectToHomePage(); // 3PC User Can't view the all Query list
      }
    }
    GoToCreateQuery() {
      this.router.navigate(['/clarification-query/create-query']);
    }
  
    pageChanged(event: any) {
      this.config.currentPage = event;
    }
  
    changePageSize() {
      this.config.itemsPerPage = this.currentPageSize;
    }
    redirectToHomePage() {
      this.router.navigate(['/home']);
    }
    canDeleteQuery(curentQueryStatus: any) {
      let canDelete = true;
      switch (curentQueryStatus) {
        case QueryStatus.Responded:
        case QueryStatus.DeletedByPartner:
        case QueryStatus.DeletedByRFCAdmin:
          canDelete = false;
          break;
      }
      return canDelete;
    }
  
    canReopenQuery(curentQueryStatus: any) {
      let canReopen = false;
      switch (curentQueryStatus) {
        case QueryStatus.Responded:
          canReopen = true;
          break;
      }
      return canReopen;
    }
    searchQuery() {
      if (this.searchText.length > 2) {
        this.filteredQueryRequest = this.myQueryRequest.filter(item => item.QueryRequestNumber.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
          || (this.currentUser.Is_Partner ? item.PartnerQueryStatus : item.QueryStatus).toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
          || item.RequestorName.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
          || item.RequestedDateInString.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
          || item.Category.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
          || item.SubCategory.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
          || item.Block.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
          || item.PriorityLevel.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
          || item.Confidential.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
          || item.Department.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
          || item.SubDeptartment.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
          || item.RespondedDateInString.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
          || item.CreatedByUserName.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
          || item.QueryReqDueDateInString.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1//);
          || (item.Subject==null?'':item.Subject.toLowerCase()).indexOf(this.searchText.toLowerCase())!==-1);
  
      }
      else if (this.searchText.length <= 2) {
        this.filteredQueryRequest = this.myQueryRequest;
      }
      this.config.currentPage = 1;
    }
    exportToExcel()
  {
    this.exportData = [];
    let currentDate = new Date();
    let exportData = [];
    let headers = ["Reference Number",
      "Request Status",
      "Requestor Name",
      "Company",
      "Block",
      "Request Date",
      "Priority",
      "Confidential",
      "Department",
      "Sub Deptartment",
      "Request Completion Date",
      "Request Created By"
    ];

    exportData = this.filteredQueryRequest.map(function (item) {
      return {
        "Reference Number": item.QueryRequestNumber,
        "Request Status": item.QueryStatus,
        "Requestor Name": item.RequestorName,
        "Company": item.CompanyName,
        "Block": item.Block,
        "Request Date": item.RequestedDate,
        "Priority" : item.PriorityLevel,
        "Confidential" : item.Confidential,
        "Department": item.Department,
        "Sub Deptartment": item.SubDeptartment,
        "Request Completion Date": item.RespondedDate,
        "Request Created By": item.CreatedByUserName
      };
    });
    this.exportData.push({ Title: 'My-Query-Request', Data: exportData, Headers: headers });
    this.xlxsService.export(this.exportData, "My-Query-Request_" + this.datepipe.transform(currentDate, 'dd-MMM-yyyy'));
  }
  sort(name: string): void {
    if (name && this.sortingName !== name) {
      this.isDesc = false;
    } else {
      this.isDesc = !this.isDesc;
    }
    this.sortingName = name;
  }
  showDeleteConfirm(queryData: QueryRequestModel): void {    
    this.modalService.confirm({
      nzTitle: 'Confirm !',
      nzContent: 'Are you sure, you want to <strong>Delete</strong> Query - <span class="referanceNumber"> '+queryData.QueryRequestNumber +'</span>?',
      nzOkText: 'Yes',
      nzWidth: '500px',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzClosable: false,
      nzAutofocus: null,
      nzOnOk: () => this.OnDeleteClick(queryData),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel')
    });
  }
  OnDeleteClick(queryData: QueryRequestModel) {    
    this.modalService.create({
      nzTitle: '<span class="referanceNumber"> Delete Query</span>',
      nzOkText: 'Delete',
      nzClosable: false,
      nzFooter: null,
      nzAutofocus: null,
      nzContent: DeleteQueryComponent,
      nzData: { paramRequestModel: queryData },
    });
  }
}
